import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FleetEventDataAccessModule } from '@navfleet/client/fleet/event/domain/data-access';
import { provideMapAutoRoutingFeature } from '@navfleet/client/map/auto-routing/domain/data-access';
import {
    MapDataLayersDataAccessModule,
    provideMapDataLayerFeature,
} from '@navfleet/client/map/data-layer/domain/data-access';
import { MapEncModule, provideMapFeatures } from '@navfleet/client/map/domain/data-access';
import { ARC_GIS_MAP_TOKEN, DATA_HUB_TOKEN, NAUTICAL_CHART_TOKEN } from '@navfleet/client/map/domain/models';
import { provideMapExpandMapFeature } from '@navfleet/client/map/expand-map/domain/data-access';
import { provideMapPortFeature } from '@navfleet/client/map/ports/domain/data-access';
import { provideMapResetFeature } from '@navfleet/client/map/reset/domain/data-access';
import { SafetyDataAccessModule, provideMapSafetyFeature } from '@navfleet/client/map/safety/domain/data-access';
import { provideMapToolsFeature } from '@navfleet/client/map/tools/domain/data-access';
import { provideMapTrackRouteFeature } from '@navfleet/client/map/track-route/domain/data-access';
import { provideMapUiSettingsFeature } from '@navfleet/client/map/ui-settings/domain/data-access';
import { UserDataLayerDataAccessModule } from '@navfleet/client/map/user-data-layer/domain/data-access';
import { provideMapUserLayerFeature } from '@navfleet/client/map/user-layer/domain/data-access';
import { provideMapVesselColorizationFeature } from '@navfleet/client/map/vessel-colorization/domain/data-access';
import { provideMapVesselFocusFeature } from '@navfleet/client/map/vessel-position-focus/domain/data-access';
import { provideMapVesselFeature } from '@navfleet/client/map/vessel/domain/data-access';
import { MapWeatherDataAccessModule, provideMapWeatherFeature } from '@navfleet/client/map/weather/domain/data-access';
import { provideMapZoomFeature } from '@navfleet/client/map/zoom/domain/data-access';
import { VesselSettingsDataAccessModule } from '@navfleet/client/monitoring/state/vessel-settings';
import { PortCustomDataAccessModule } from '@navfleet/client/port/custom/domain/data-access';
import { ReferenceDataCountriesDataAccessModule } from '@navfleet/client/reference-data/countries/domain/data-access';
import { ReferenceDataUnitsDataAccessModule } from '@navfleet/client/reference-data/units/domain/data-access';
import { SettingsNotificationRuleDataAccessModule } from '@navfleet/client/settings/notification/domain/data-access';
import { fromRoot } from '@navfleet/client/shell/domain/data-access';
import { TenantSettingsDataAccessModule } from '@navfleet/client/tenant/settings/domain/data-access';
import { UserDataAccessModule } from '@navfleet/client/user/domain/data-access';
import { UserSettingsDataAccessModule } from '@navfleet/client/user/settings/domain/data-access';
import { WeatherEarthquakeDataAccessModule } from '@navfleet/client/weather/earthquake/domain/data-access';
import '@navfleet/shared/extensions';
import { EffectsModule, provideEffects } from '@ngrx/effects';
import { StoreModule, provideStore } from '@ngrx/store';
import { ClientShellRoutingModule } from './client-shell-routing.module';
import { provideStoreDevtoolsBaseOnEnv } from './store-devtools.provider';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forRoot(fromRoot.ROOT_REDUCERS),
        EffectsModule.forRoot(fromRoot.ROOT_EFFECTS),
        TenantSettingsDataAccessModule,
        ReferenceDataCountriesDataAccessModule,
        UserDataAccessModule,
        ClientShellRoutingModule,
        MapWeatherDataAccessModule,
        WeatherEarthquakeDataAccessModule,
        MapEncModule,
        MapDataLayersDataAccessModule,
        UserDataLayerDataAccessModule,
        SafetyDataAccessModule,
        SettingsNotificationRuleDataAccessModule,
        FleetEventDataAccessModule,
        UserSettingsDataAccessModule,
        VesselSettingsDataAccessModule,
        PortCustomDataAccessModule,
        ReferenceDataUnitsDataAccessModule,
    ],
    exports: [RouterModule],
    providers: [
        provideStore(fromRoot.ROOT_REDUCERS),
        provideEffects(fromRoot.ROOT_EFFECTS),
        provideStoreDevtoolsBaseOnEnv(),
        { provide: ARC_GIS_MAP_TOKEN, useValue: { token: '' } },
        { provide: DATA_HUB_TOKEN, useValue: { token: '' } },
        { provide: NAUTICAL_CHART_TOKEN, useValue: { token: '' } },
        provideMapFeatures(
            provideMapWeatherFeature(),
            provideMapExpandMapFeature(),
            provideMapZoomFeature(),
            provideMapVesselFocusFeature(),
            provideMapPortFeature(),
            provideMapVesselColorizationFeature(),
            provideMapDataLayerFeature(),
            provideMapUiSettingsFeature(),
            provideMapTrackRouteFeature(),
            provideMapToolsFeature(),
            provideMapAutoRoutingFeature(),
            provideMapResetFeature(),
            provideMapSafetyFeature(),
            provideMapVesselFeature(),
            provideMapUserLayerFeature()
        ),
    ],
})
export class ClientShellModule {}
